import E from "./index.es472.js";
var s = "Recent",
    n = "BUTTON",
    _ = "Space",
    y = "recentEmojis",
    p = E.reduce(function (e, o) {
  if (o.category === "People & Body") {
    var t = "Smileys & Emotion";
    e[t] = e[t] || [], e[t].push(o);
  } else e[o.category] = e[o.category] || [], e[o.category].push(o);

  return e;
}, {});
export { s as DEFAULT_CATEGORY, _ as EMOJI_FOCUS_KEY_CODE, y as EMOJI_LOCALSTORAGE_KEY, n as EMOJI_WRAPPER_TAG, p as GROUPED_EMOJIS };